import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TabHeader from './tab_header';

// An ordered group of clickable headers, one of which is active.
export default function TabHeaders ({ children, activeName, className, onActivate }) {
  const clonedChildren = React.Children.map(children,
    child => React.cloneElement(child, {
      activeName,
      onClick: () => onActivate(child.props.name),
    }),
  );

  return <div className={classnames('tab-headers', className)}>{clonedChildren}</div>;
}

TabHeaders.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.oneOf([TabHeader]) })).isRequired,
  activeName: PropTypes.string,
  className: PropTypes.string,
  onActivate: PropTypes.func,
};

TabHeaders.defaultProps = {
  className: '',
  activeName: null,
  onActivate: () => {},
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tab_headers.jsx